module.exports = __webpack_public_path__ + "static/media/allergy_p2_2.249d18ea.png";